import React, { useEffect, useState } from 'react'
import { Redirect } from 'react-router-dom'
import {useCookies} from "react-cookie";

const ProtectedRoute = (props) => {
  const [cookies, ] = useCookies(['auth_token'])
  const Component = props.component;
  const [, refresh] = useState(0)

  useEffect(() => props.session ? props.session.subscribe(() => refresh(value => value + 1)) : undefined, [props.session])

  const isAuthenticated = () => {
    if (props.session) return props.session.check()
    if (cookies.auth_token){
      return true
    }
  };

  // A mutation owns the destination until it commits or fails. Redirecting here
  // would unmount its owner before logout can complete that single navigation.
  if (props.session && props.session.getSnapshot().phase === 'transitioning') return null

  return isAuthenticated() ? (
    props.render ? props.render(props) : <Component {...props} />
  ) : (
    <Redirect to={{ pathname: '/login' }} />
  );

}

export default ProtectedRoute;
